import React from "react";

export default function Tarif(){

    return(

               <section id="tarif" style={{minHeight: '100vh',  overflow: 'auto',padding: '6em 0'}}>
            <div className="container">
                <div className="panel panel-default cadresshadows">
                    <div className="panel-heading text-center">
                        <h1>TARIFS DES CONSULTATIONS</h1>
                    </div>
    
                    <div className="row">
                        <div className="col-lg-6 text-center">
                            <h2>SÉANCES AU CABINET</h2>
                            <p>
                                <img src="resources/img/puce.png" style={{verticalAlign: 'middle'}} alt="puce" />
                                <span>50 euros sur Paris</span>
                            </p>
                        </div>
                        <div className="col-lg-6 text-center">
                            <h2>SÉANCES À DOMICILE</h2>
                            <p>Région: Paris et 1ère couronne</p>
                            <p>
                                <img src="resources/img/puce.png" style={{verticalAlign: 'middle'}} alt="puce" />
                                <span>60 euros</span>
                            </p>
                        </div>
                    </div>
                    <div className="row" style={{paddingTop: '2em'}}>
                        <div className="col-lg-12 text-center">
                            <p>Chaque séance peut durer entre 30 et 45 minutes suivant la
                                spécificité de votre pathologie.</p>
                            <br /> <br />
                            <p>
                                <span style={{textDecoration: 'underline', fontSize: '1.2em',color: '#ff3300'}}>Attention :</span>
                            </p>
                            <br />
                            <p>&#160;&#160;&#160;Le magnétisme soigne très bien les
                                maladies de peau,les douleurs ...</p>
                            <p>Mais en aucun cas certaines maladies graves, comme le
                                Cancer. (Néanmoins le magnétisme peut aider à supporter les
                                effets secondaires de différents traitements).</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>



    )



}